<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Miscellaneous</h1>
      <div class="text-large">Just some posts we thought you would like.</div>
    </div>
  </div>
<Posts Category="misctexts" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
